module.exports = "/images/laser tag (flatten-working).svg?a0255a1e2861ed336589bc204f57a737";